import { Languages, SearchableGlossaryTermInstantSearch } from '@livv/models';
import { completePreviewLink, getGlossaryTermLink } from '@livv/utils/helpers';
import { fromUnixTime } from 'date-fns';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import ContentCard, { PreviewCardProps } from '@components/search/preview/ContentCard';
import { APP_URL } from '@utils/consts/livv';
import { useFreemiumDialog } from '@utils/context/freemiumDialog';
import { getDate } from '@utils/date';
import { getFullTextSearchQuery } from '@utils/search/snippet';

interface GlossaryTermPreviewProps extends PreviewCardProps<SearchableGlossaryTermInstantSearch> {
    query: string;
}

const GlossaryTermPreview: FC<GlossaryTermPreviewProps> = ({ hit, query }) => {
    const { openFreemiumDialog } = useFreemiumDialog();
    const { t, lang } = useTranslation('glossary');
    const { baseObjectID, redirectionId, updatedAt } = hit;
    const href = getGlossaryTermLink(redirectionId || baseObjectID);

    return (
        <ContentCard
            hit={hit}
            href={completePreviewLink(
                href,
                APP_URL,
                redirectionId ? undefined : getFullTextSearchQuery(hit, query),
            )}
            onClick={openFreemiumDialog}
            secondaryAttributes={[
                {
                    attribute: getDate(fromUnixTime(updatedAt), lang as Languages),
                    label: t('updatedAt'),
                },
            ]}
            snippetAttribute="fullText"
            subtitleAttributes={[{ attribute: 'description' }]}
            titleAttribute="title"
        />
    );
};

export default GlossaryTermPreview;
